import styled from "styled-components";

export const SectionWrapper = styled.div`
`;